// src/com/sms_phrases/SmsPhrasesDict.js
import { InputType, TableColumnType } from "../../value/AppConst";
import IsValid from "../../value/IsValid";

// SMS 메시지를 보낼때 자주 사용하는 문구, sms_phrases
const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    smsPhrasesSeq : {
		id: 'smsPhrasesSeq', required: true, toAdd: false, toEdit: true,
	}, // int(11)
    phrase : {
		id: 'phrase', label: '메시지 문구',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '400자 이내로 입력하세요.',
        min: 5, max: 400,
		check: (value) => {return IsValid.string(value, 5, 400)},
	}, // varchar(400)
};

/**
 * SMS_PHRASES React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2025-01-24 15:26:30 using DbdbTap
 * https://www.dbdbtap.com
 */
export const SmsPhrasesDictionary = {
    inputMap: Dict,
    errorTitle: {
        Add: '자주쓰는 문구 등록 오류',
        Edit: '자주쓰는 문구 수정 오류',
        Remove: '자주쓰는 문구 삭제 오류',
        Get: '자주쓰는 문구 조회 오류',
    },
    tableProps: {
        tableId: 'smsPhrasesTable',
        uniqueKey: 'smsPhrasesSeq',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            hideBubble: false,
            growToFill: true,
        },
        columns: [
            //print using getTableColumnOption(c,t,i)
            { id: 'phrase', label: Dict.phrase.label, width: 270, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'regDate', label: "등록일", width: 90, show: true, option:{align: 'inherit', print:(r,i,v)=>v?v.substring(0,10):'-'} },
            { id: 'userName', label: "등록자", width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
        ]
    },
};
